<template>
  <b-tooltip :type="is_tv || is_v" :label="h" class="mr-2">
    <b-tag @click="$emit('click', text)" :type="is_v" size="is-medium"
      :class="`${tv} ${light ? 'is-light' : ''}`">
      <slot>
        <font-awesome-icon v-if="icon" :icon="icon" class="mr-2" />
        {{ text }}
      </slot>
    </b-tag>
  </b-tooltip>
</template>

<script>
export default {
  emits: ['click'],
  props: {
    variant: String,
    hint: String,
    text: String,
    icon: [String, Array],
    textVariant: String,
    light: Boolean,
  },
  computed: {
    v () { return this.variant || 'light' },
    is_v () { return `is-${this.v}`},
    ht_v () { return `has-text-${this.v}` },
    h () { return this.hint || this.text },
    is_tv () {
      if (!this.textVariant) return null
      return `is-${this.textVariant}`
    },
    tv () {
      if (!this.textVariant) return null
      return `has-text-${this.textVariant}`
    }
  }
}
</script>